  <!-- generic toast and dialog -->
  <p-toast />
  <p-confirmDialog />
  <!-- end alerts and dialog -->
<div [ngClass]="{ dark: this.themeService.isDark }">
  <router-outlet></router-outlet>
</div>
